export default "__VITE_ASSET__Ce2Gq3er__"